import { alpha, styled } from '@mui/material/styles';
import Tabs, { TabsProps } from '@mui/material/Tabs';

export const AppTabs = styled((props: TabsProps) =>
(
    <Tabs
        {...props}
    />
))(
    ({ theme }) => ({
        '& .MuiTabs-indicator': {
            height: "4px",
            backgroundColor: theme.palette.error.main
        },
    })
);


export const AppBarTabs = styled((props: TabsProps) =>
(
    <Tabs
        {...props}
        textColor="inherit"
    />
))(
    ({ theme }) => ({
        color: alpha(theme.palette.common.white, 0.7),
        '& .Mui-selected': {
            color: theme.palette.common.white,
        },
        '& .MuiTabs-indicator': {
            height: "4px",
            backgroundColor: theme.palette.error.main
        },
    })
);